import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as formEditorActions from './formEditor.actions';
import * as formTemplatesActions from '../formTemplates/formTemplates.actions';
import FormEditorWizard from './formEditorWizard';


function mapStateToProps(state) {
  return {
    isLoading: state.formTemplates.isLoading,
    defaultTemplates: state.formTemplates.defaultTemplates,
  };
}

function mapActionsToProps(dispatch) {
  return bindActionCreators({
    ...formEditorActions,
    ...formTemplatesActions,
  }, dispatch);
}

export default connect(mapStateToProps, mapActionsToProps)(FormEditorWizard);
